import { render, staticRenderFns } from "./EModalJustificarFalta.vue?vue&type=template&id=17c9d613&scoped=true"
import script from "./EModalJustificarFalta.vue?vue&type=script&lang=js"
export * from "./EModalJustificarFalta.vue?vue&type=script&lang=js"
import style0 from "./EModalJustificarFalta.vue?vue&type=style&index=0&id=17c9d613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c9d613",
  null
  
)

export default component.exports